class Loader {
    constructor(loader) {
        if (!loader) return;

        this.loader = loader;
        this.pp = document.documentElement.getAttribute('data-pp');

        this.init();
    }

    init() {
        this.registerEvents();
    }

    registerEvents() {
        document.addEventListener('DOMContentLoaded', this.load.bind(this));
    }

    load(e) {
        this.loader.classList.add('is-loaded');

        if (this.getSSItem('ppid') === null) {
            this.animate('fade');
        } else {
            if (this.getSSItem('ppid') == this.pp) {
                this.animate('fade');
            } else {
                this.animate('height');
            }
        }

        this.setSSItem('ppid', this.pp);
    }

    animate(type) {
        const that = this;
        if (type == 'fade') {
            setTimeout(function() {
                that.loader.style.opacity = '0';

                that.loader.addEventListener('transitionend', function() {
                    that.loader.style.visibilty = 'hidden';
                    that.loader.style.pointerEvents = 'none';
                });
            }, 600);
        } else if (type == 'height') {
            setTimeout(function() {
                that.loader.style.height = '50%';
                that.loader.style.clipPath = 'polygon(0 0, 100% 0, 100% 0%, 0 0%)';

                that.loader.addEventListener('transitionend', function() {
                    that.loader.style.visibilty = 'hidden';
                    that.loader.style.pointerEvents = 'none';
                });
            }, 600);
        }
    }

    getSSItem(item) {
        return sessionStorage.getItem(item);
    }

    setSSItem(item, value) {
        return sessionStorage.setItem(item, value);
    }
}

new Loader(document.querySelector('.loader'));
